import Joi from "joi";
const patientSchema = Joi.object({
    title: Joi.string()
        .valid('Mr.', 'Mrs.', 'Dr.', 'Ms.', 'Prof.', 'Er.', 'Sister', 'Rev.', 'Capt.', 'Col.', 'Maj.', 'None')
        .allow('')
        .optional(),
    firstName: Joi.string().min(1).max(50).required(),
    lastName: Joi.string().min(1).max(50).required(),
    contactNo: Joi.string().pattern(/^\d{10}$/).required().messages({
        'string.pattern.base': 'Contact number must be exactly 10 digits.',
    }),
    city: Joi.string().min(1).max(100).required(),
    state: Joi.string().min(1).max(100).required(),
    age: Joi.number().integer().min(0).max(120).required(),
    address: Joi.string().min(1).max(255).required(),
    emergencyContactName: Joi.string().min(1).max(50).required(),
    emergencyContactNumber: Joi.string().pattern(/^\d{10}$/).required().messages({
        'string.pattern.base': 'Emergency contact number must be exactly 10 digits.',
    }),
    emergencyContactRelationship: Joi.string().min(1).max(50).required(),
    gender: Joi.string().valid('male', 'female', 'other').required(),
    pinCode: Joi.string().pattern(/^\d{6}$/).required().messages({
        'string.pattern.base': 'Pin code must be exactly 6 digits.',
    }),
}).unknown(true);

export default patientSchema;